;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React from "react"
import Svg from "../../../../../assets/groups-i-lead-v2.svg"

export default function GroupsILeadIcon() {
  return (
    <Svg
      width={21}
      height={20}
      viewBox="0 0 21 20"
      className="inline-block shrink-0 select-none"
      // Matches the previous SvgIcon fill override: rgb(217, 217, 217, 0)
      style={{ fill: "transparent" }}
      aria-hidden="true"
      focusable="false"
    />
  )
}
